import createAction from './createAction';

// because icepick is implemented using commonjs modules,
// which we don't suppport, it has to be required in this way
const icepick = require('../../../node_modules/icepick/icepick.min');

// 1. Initial state
const initialState = icepick.freeze({
  // Initially react will not render products into listing page,
  // server rendered products will remain on page until user clicked on some page in paginator.
  renderReactProductList: false,
  xhrStatus: {
    pendingLocationRequest: false,
    pendingProductsRequest: false,
    productsPostXhrError: null,
    xhrDisplayWarning: false
  },
  islocationSearchEnabled: false

});

// 2. Actions
const SET_COUNTDOWN_CLASS_SUFFIX = 'listingPage/pageSetup/SET_COUNTDOWN_CLASS_SUFFIX';
const SET_VIEW_SWITCH = 'listingPage/pageSetup/SET_VIEW_SWITCH';
const SET_SORT_BY_OPTIONS = 'listingPage/pageSetup/SET_SORT_BY_OPTIONS';
const SET_CATEGORY = 'SET_CATEGORY';
const SET_RENDER_REACT_PRODUCT_LIST = 'listingPage/pageSetup/SET_RENDER_REACT_PRODUCT_LIST';
const SET_PENDING_LOCATION_REQUEST = 'listingPage/pageSetup/SET_PENDING_LOCATION_REQUEST';
const SET_PENDING_PRODUCTS_REQUEST = 'listingPage/pageSetup/SET_PENDING_PRODUCTS_REQUEST';
const SET_PRODUCTS_POST_XHR_ERROR = 'listingPage/pageSetup/SET_PRODUCTS_POST_XHR_ERROR';
const TOGGLE_XHR_ERROR_WARNING = 'listingPage/pageSetup/TOGGLE_XHR_ERROR_WARNING';
const SET_LOCATION_SEARCH_ENABLED = 'listingPage/pageSetup/SET_LOCATION_SEARCH_ENABLED';

// 3. Action creators
export function setCountdownClassSuffix(countdownClassSuffix) {
  return createAction(SET_COUNTDOWN_CLASS_SUFFIX)(countdownClassSuffix);
}

export function setViewSwitch(viewSwitch) {
  return createAction(SET_VIEW_SWITCH)(viewSwitch);
}

export function setSortByOptions(sortByOptions) {
  return createAction(SET_SORT_BY_OPTIONS)(sortByOptions);
}

export function setCategory(category) {
  return createAction(SET_CATEGORY)(category);
}

export function setRenderReactProductList() {
  return (dispatch, getState) => {
    if (getState().listingPage.pageSetup.renderReactProductList === false) {
      dispatch(createAction(SET_RENDER_REACT_PRODUCT_LIST)());
    }
  };
}

export function setPendingLocationRequest(isPending) {
  return createAction(SET_PENDING_LOCATION_REQUEST)(isPending);
}

export function setPendingProductsRequest(isPending) {
  return createAction(SET_PENDING_PRODUCTS_REQUEST)(isPending);
}

export function setProductsPostXhrError(errData) {
  return createAction(SET_PRODUCTS_POST_XHR_ERROR)(errData);
}

export function toggleXhrErrorWarning(isApproved) {
  return createAction(TOGGLE_XHR_ERROR_WARNING)(isApproved);
}

export function setLocationSearchEnabled(isEnabled) {
  return createAction(SET_LOCATION_SEARCH_ENABLED)(isEnabled);
}

// 4. Reducer
export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case SET_COUNTDOWN_CLASS_SUFFIX: {
      return icepick.setIn(state, ['countdownClassSuffix'], action.payload);
    }
    case SET_VIEW_SWITCH: {
      return icepick.setIn(state, ['viewSwitch'], action.payload);
    }
    case SET_SORT_BY_OPTIONS: {
      return icepick.setIn(state, ['sortByOptions'], action.payload);
    }
    case SET_CATEGORY: {
      return icepick.setIn(state, ['category'], action.payload);
    }
    case SET_RENDER_REACT_PRODUCT_LIST: {
      return icepick.setIn(state, ['renderReactProductList'], true);
    }
    case SET_PENDING_LOCATION_REQUEST: {
      return icepick.setIn(state, ['xhrStatus', 'pendingLocationRequest'], action.payload);
    }
    case SET_PENDING_PRODUCTS_REQUEST: {
      return icepick.setIn(state, ['xhrStatus', 'pendingProductsRequest'], action.payload);
    }
    case SET_PRODUCTS_POST_XHR_ERROR: {
      return icepick.setIn(state, ['xhrStatus', 'productsPostXhrError'], action.payload);
    }
    case TOGGLE_XHR_ERROR_WARNING: {
      return icepick.setIn(state, ['xhrStatus', 'xhrDisplayWarning'], action.payload);
    }
    case SET_LOCATION_SEARCH_ENABLED: {
      return icepick.setIn(state, ['islocationSearchEnabled'], action.payload);
    }
    default: {
      return state;
    }
  }
}
